import {atom, SetStateAction, useAtom} from 'jotai';

// @ts-ignore
type TUseLoadingReturn = [boolean, SetAtom<[SetStateAction<boolean>], void>]
export const loadingAtom = atom<boolean>(false);

const useLoading = (params?: boolean): TUseLoadingReturn  => {
  const [loading, setLoading] = useAtom(loadingAtom);
  if (params) setLoading(params);
  return [loading, setLoading];
};

export default useLoading;
